import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { AccessSubjectTypes, IAccessRightsMetadata, IEntityAccessRights } from 'common/interfaces/access-rights';

const entityAccessRights = createSlice({
  name: 'entityAccessRights',
  initialState: {
    isLoading: false,
    accessRights: [] as IEntityAccessRights[],
    metadata: [] as IAccessRightsMetadata[],
    error: null,
  },
  reducers: {
    entityAccessRightsRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    entityAccessRightsRecieved: (state, action) => {
      state.isLoading = false;
      state.accessRights = action.payload.accessRights ?? [];
      state.metadata = action.payload.metadata ?? [];
    },
    entityAccessRightsFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
});

export const {
  entityAccessRightsRequested,
  entityAccessRightsRecieved,
  entityAccessRightsFailed,
} = entityAccessRights.actions;

export default entityAccessRights.reducer;

export const getEntityAccessRightsList = (type: string, id: string, subjecttype: AccessSubjectTypes) => apiCallBegan({
  url: `/entity-access-rights-list?type=${type}&id=${id}&subjecttype=${subjecttype}`,
  method: 'GET',
  onStart: entityAccessRightsRequested.type,
  onSuccess: (response: IEntityAccessRights[]) => ({
    type: entityAccessRightsRecieved.type,
    payload: response,
  }),
  onError: entityAccessRightsFailed.type,
});
